import { React, FC, useContext, useMemo} from 'external/react'
import {styled} from 'external/material'

import { TeacherContext } from 'teacher/context'
import { SelectField } from 'components/common/SelectField'


const StyledSelectGroup = styled(SelectField)(selectGroupStyles as any)

type SelectGroupProps = {
  className?: string
}

const SelectGroup: FC<SelectGroupProps> = props => {

    const {className} = props
    const {newPlan, updateState, groups, translate} = useContext(TeacherContext) as any

    const updatePlan = (commands: any) => updateState({newPlan: commands})

    const groupList = useMemo(() => (groups || []).map((group:any) => ({...group, label: group.name, value: group.id})), [groups])
    const group = useMemo(() => groupList.find((group:any) => group.value === newPlan.clique), [groupList, newPlan.clique])

    return (
      <StyledSelectGroup
          className={className}
          label={translate('group-label')}
          onChange={(option:any) => {
            updatePlan({clique: {$set: option.value}, subject: {$set: option.course.substring(0, 2)}, grade: {$set: option.course.substring(4)}}) }
          }
          options={groupList}
          value={group}
        />
      )
}

function selectGroupStyles() {
  return {

  }
}


export { SelectGroup as default }